import { EstimateFile } from "@/enums/estimate-file";
import { EstimateType } from "@/enums/estimate-type";

export const DOCUSKETCH_PLAYER_URL_REGEX = /https:\/\/app\.docusketch\.com\/player\/([^/?#]+)/;

export type DocusketchUploadState = "EMPTY" | "VALIDATING" | "VALIDATION_PASSED" | "INVALID";

export const DOCUSKETCH_UPLOAD_STATE_MESSAGES: Record<DocusketchUploadState, { color: string; message: string }> = {
  EMPTY: { color: "", message: "" },
  VALIDATING: { color: "text-blue-500", message: "Validating link..." },
  VALIDATION_PASSED: { color: "text-green-500", message: "Validated 3D scan link" },
  INVALID: {
    color: "text-red-500",
    message: "Please verify your DocuSketch link is correct and publicly accessible",
  },
};

interface FileUploadConfig {
  showFileUpload: boolean;
  fileType: EstimateFile;
  title: string;
  postUploadCommand: string;
}

export function getFileUploadConfig(estimateType: EstimateType | undefined): FileUploadConfig {
  switch (estimateType) {
    case EstimateType.MITIGATION:
    case EstimateType.MOLD:
    case EstimateType.FIRE_MITIGATION:
      return {
        showFileUpload: true,
        fileType: EstimateFile.MITIGATION_REPORT,
        title: "Mitigation Report",
        postUploadCommand: "",
      };
    case EstimateType.CONTENTS:
      return {
        showFileUpload: true,
        fileType: EstimateFile.CONTENTS_TEMPLATE,
        title: "Contents Template",
        postUploadCommand: "",
      };
    case EstimateType.RECONSTRUCTION:
      return { showFileUpload: false, fileType: EstimateFile.OTHER, title: "", postUploadCommand: "" };
    case EstimateType.BIOHAZARD:
    case EstimateType.TIME_AND_MATERIAL:
    default:
      return { showFileUpload: false, fileType: EstimateFile.OTHER, title: "", postUploadCommand: "" };
  }
}
